import React from 'react';

const HRMS = ({style = {}, size = "36", className = "", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d="M17.845 12.285l-4.162 3.795-.006.008-6.338-5.913 3.72-4.213 2.169 2.018 4.617 4.306v-.001zm10.61-1.9l-6.4 5.83-4.21-3.93 4.766-4.349 2.087-1.907 3.756 4.355z"
            fill="#007AFF"
        />
        <path
            d="M22.056 16.217a5.85 5.85 0 01-8.138.098l-.246-.227.007-.006 4.155-3.796 4.222 3.931z"
            fill="url(#prefix__paint0_linear)"
        />
        <path
            d="M17.896 8.926c1.86 0 3.367-1.55 3.367-3.463S19.756 2 17.896 2 14.53 3.55 14.53 5.463s1.507 3.463 3.366 3.463z"
            fill="#FFA700"
        />
        <path
            d="M24.079 23.457l-1.034-5.617-.006-.012 8.18-2.565 1.615 5.443-2.8.88-5.955 1.87zm-3.85 10.347l-1.584-8.637v-.006l5.435-1.704 1.184 6.44.526 2.825-5.561 1.082z"
            fill="#007AFF"
        />
        <path
            d="M18.643 25.162a6.272 6.272 0 01.694-4.51 6.007 6.007 0 013.39-2.732l.31-.097v.012l1.036 5.616-5.43 1.71z"
            fill="#60B158"
        />
        <path
            d="M29.747 30.463c1.86 0 3.367-1.55 3.367-3.463s-1.507-3.463-3.366-3.463c-1.86 0-3.367 1.55-3.367 3.463s1.507 3.463 3.366 3.463z"
            fill="#FFA700"
        />
        <path
            d="M11.06 23.519l1.226-5.574v-.012l-8.084-2.86-1.8 5.382 2.769.978 5.89 2.086z"
            fill="#007AFF"
        />
        <path
            d="M14.552 34l1.885-8.582-5.376-1.901-1.406 6.398-.616 2.8L14.552 34z"
            fill="#007AFF"
        />
        <path
            d="M16.435 25.42a6.274 6.274 0 00-.544-4.528c-.748-1.395-1.938-2.374-3.295-2.848l-.311-.111v.012l-1.226 5.574 5.376 1.901z"
            fill="#60B158"
        />
        <path
            d="M5.366 30.034c1.86 0 3.367-1.551 3.367-3.464s-1.507-3.464-3.367-3.464C3.508 23.106 2 24.656 2 26.57c0 1.913 1.508 3.463 3.366 3.463z"
            fill="#FFA700"
        />
        <defs>
            <linearGradient
                id="prefix__paint0_linear"
                x1={17.864}
                y1={12.287}
                x2={17.864}
                y2={17.915}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#60B158" />
                <stop offset={1} stopColor="#60B158" />
            </linearGradient>
        </defs>
    </svg>
);

export default HRMS;